/*global mzFunc, mzImage360, PhotoSphereViewer */

import React from 'react';

import { Pannellum } from "pannellum-react";
import GTMHelper from '../../../Helpers/gtmHelper';


export const ThreeSixtyInteriorView = ({ imagePath, ...props }) => {
	const gtmHelper = new GTMHelper();
	const [panoramaIsReady, setPanoramaIsReady] = React.useState(false);

	window.addEventListener('resize', set360Height);

	function set360Height(){
		const container = document.querySelector('.mz-360-container');
		const subnav =  document.querySelector('.mz-sticky-submenu');
		const pricing = document.querySelector('.mz-pricing');
		const imageCont = document.querySelector('.mz-360-image-container__interior');
		const title = document.querySelector('.mz-360-container__tittle');
		const controls = document.querySelector('.mz-360-container__controls');
		if(imageCont !== null && controls !== undefined && container){
			if(window.innerWidth > 1023 && subnav !== undefined && pricing !== undefined && pricing != null){
				const alert = mzFunc ? mzFunc.offsetAlert : 0;
				const permAlert = mzFunc ? mzFunc.offsetPermAlert : 0;
				const menu = mzFunc ? mzFunc.offsetMenu : 0;
				let viewHeight = window.innerHeight - ( alert + permAlert + menu + (subnav ? subnav.clientHeight : 0) + (pricing ? pricing.clientHeight : 0));
				//viewHeight = viewHeight<450? 450 : viewHeight;
				imageCont.style.height= (viewHeight - (title.clientHeight + (controls ? controls.clientHeight : 0))) +'px';
				container.dataset['height']=imageCont.style.height;
			}else{
				//container.dataset['height']=imageCont.clientHeight + 'px';
				imageCont.style.height=window.innerHeight/3 +'px';
			}
		}
	}

	function enablePanorama(){
		const interiorEl = document.querySelector('.mz-360-image-container__interior');
		set360Height();
		interiorEl.innerHTML='';
		console.log(document.getElementById('interiorModal'))
		if(!document.getElementById('interiorModal')){
			const fullScreen = document.createElement('div');
			fullScreen.classList.add('mz-modal');
			fullScreen.id='interiorModal';
			fullScreen.setAttribute('aria-hidden', 'true');
			document.body.appendChild(fullScreen);
		}
		console.log(document.getElementById('interiorModal'))
		mzImage360.showPanorama(interiorEl, imagePath);
	}

	React.useEffect(() => {
		if(!panoramaIsReady){
			const ref = setInterval(() => {
				if(typeof PhotoSphereViewer == 'object') {
					enablePanorama();
					clearInterval(ref);
				}
			}, 100);
		}		
	}, [imagePath]);

	// <Pannellum
	// 	        width="100%"
	// 	        height={set360Height()}
	// 	        image={imagePath}
	// 	        pitch={-15}
	// 	        yaw={-90}
	// 	        autoLoad={true}
	// 			mouseZoom={false}
	// 			keyboardZoom={false}
	// 			showZoomCtrl={false}
	// 			showFullscreenCtrl={true}
	// 			orientationOnByDefault={false}
	// 			onMousedown={(evt)=>gtmHelper.setGTM({'action':'Drag Interior'}, true , false)}
	// 			onTouchstart={(evt)=>gtmHelper.setGTM({'action':'Drag Interior'}, true , false)}
	// 	    >
	// 	    </Pannellum>

	return(
		<div className="mz-360-image-container__interior">
		    
		</div>
	)
}

export default ThreeSixtyInteriorView;